<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{ $lang('在线文档') }}</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST, OPEN_API_PRO} from '@/constants/index'

const apiUrlTest = 'order/addOrder';
export default {
  components: {onlineDoc, apiTestDoc},
  data() {
    const that = this
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: that.$lang(`与平台签约的客户，可通过此接口创建订单。`),
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
        postDataList: [

          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: "apiAccount",
                type: "Number",
                require: "Y",
                normal: "",
                describe: that.$lang("接入方在平台的api账户标识")
              },
              {name: "digest", type: "String", require: "Y", normal: "", describe: that.$lang("签名字符串,请在签名工具内获取")},
              {
                name: "timestamp",
                type: "Number",
                require: "Y",
                normal: "",
                describe: that.$lang('时间戳，毫秒') + "<br/>" + that.$lang('时区：UTC+7'),
                isHtml: true
              },
            ]
          },
          {
            title: '请求参数',
            value: [
              {
                name: "bizContent",
                type: "String",
                require: "Y",
                normal: that.$lang("业务参数"),
                describe: that.$lang("业务参数模块内json格式的string类型")
              },
            ]
          },
          {
            title: "业务参数",
            value: [
              {
                name: "customerCode",
                type: "String(30)",
                require: "Y",
                normal: "084LC02000",
                describe: that.$lang("客户编码（客户合作网点提供）")
              },
              {
                name: "password",
                type: "String",
                require: "Y",
                normal: that.$lang("明文密码：H5CD3zE6"),
                describe: that.$lang("客户资料提供的开平账号密码")
              },
              {
                name: "txlogisticId",
                type: "String",
                require: "Y",
                normal: "TESTID000001",
                describe: that.$lang('Customer Order ID客户订单号') + "<br/>" + that.$lang('不支持重复'),
                isHtml: true
              },
              {
                name: "orderType",
                type: "int",
                require: "Y",
                normal: "1",
                describe: that.$lang('订单类型，默认传1') + '<br/>' + that.$lang('1=普通订单') + '<br/>' + that.$lang('2=退货订单'),
                isHtml: true
              },
              {
                name: "selfAddress",
                type: "int",
                require: "N",
                normal: that.$lang('0: 使用J&T提供的地址库') + "<br/>" + that.$lang('1: 使用J&T行政区划映射地址'),
                describe: that.$lang('传地址方式'),
                isHtml: true
              },
              {
                name: "serviceType",
                type: "int",
                require: "Y",
                normal: "1",
                describe: that.$lang('服务类型') + '<br/>' + that.$lang('1=上门取件') + '<br/>' + that.$lang('6=门店寄件'),
                isHtml: true
              },
              {
                name: "payType",
                type: "String",
                require: "Y",
                normal: "PP_PM",
                describe: `<p>${that.$lang('支付方式')}:</p><p>${that.$lang('PP_PM：寄付月结')}</p><p>${that.$lang('PP_CASH：寄付现结')}</p><p>${that.$lang('CC_CASH：到付现结')}</p`,
                isHtml: true
              },
              {
                name: "productType",
                type: "String",
                require: "Y",
                normal: "EXPRESS",
                describe: `<p>${that.$lang('产品类型')}:</p><p>${that.$lang('枚举值：EXPRESS 、FAST、SUPER')}</p>`,
                isHtml: true
              },
              {
                name: "goodsType",
                type: "String",
                require: "Y",
                normal: "bm000001",
                describe: that.$lang('物品类型，传编码') + '<br/>' + that.$lang('bm000001-文件') + '<br/>' + that.$lang('bm000010-物品') + '<br/>' + that.$lang('bm000011-生鲜'),
                isHtml: true
              },
              {
                name: "partSign",
                type: "String(1)",
                require: "N",
                normal: "",
                describe: that.$lang('签收类型') + '<br/>' + that.$lang('1：部分签收') + '<br/>' + that.$lang('0：全部签收'),
                isHtml: true
              },
              {
                name: "deliveryType",
                type: "int",
                require: "Y",
                normal: "",
                describe: that.$lang('派送类型') + '<br/>' + that.$lang('1：正常派送') + '<br/>' + that.$lang('2：自提件'),
                isHtml: true
              },
              {
                name: "exchange",
                type: "string",
                require: "N",
                normal: "1",
                describe: that.$lang('退换货标识:') + '<br/>' + that.$lang('1=支持退换货') + '<br/>' + that.$lang('0=不支持退换货'),
                isHtml: true
              },
              {
                name: "sender",
                type: "Object",
                require: "Y",
                normal: "",
                describe: that.$lang('寄件信息对象'),
                children: [
                  {name: "name", type: "String(40)", require: "Y", normal: "", describe: that.$lang('寄件人姓名')},
                  {name: "mobile", type: "String(30)", require: "Y", normal: "", describe: that.$lang('寄件人电话')},
                  {name: "prov", type: "String(40)", require: "Y", normal: "", describe: that.$lang('寄件人省')},
                  {name: "city", type: "String(40)", require: "N", normal: "", describe: that.$lang('寄件人市')  + '<br/>' + that.$lang('新地址无需填该字段'), isHtml: true },
                  {name: "area", type: "String(40)", require: "Y", normal: "", describe: that.$lang('寄件人区')},
                  {
                    name: "address",
                    type: "String(250)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('寄件人详细地址')
                  },
                ]
              },
              {
                name: "receiver",
                type: "Object",
                require: "Y",
                normal: "",
                describe: that.$lang('收件信息对象'),
                children: [
                  {name: "name", type: "String(40)", require: "Y", normal: "", describe: that.$lang('收件人姓名')},
                  {name: "mobile", type: "String(30)", require: "Y", normal: "", describe: that.$lang('收件人电话')},
                  {name: "prov", type: "String(40)", require: "Y", normal: "", describe: that.$lang('收件人省')},
                  {name: "city", type: "String(40)", require: "N", normal: "", describe: that.$lang('收件人市')  + '<br/>' + that.$lang('新地址无需填该字段'), isHtml: true },
                  {name: "area", type: "String(40)", require: "Y", normal: "", describe: that.$lang('收件人区')},
                  {
                    name: "address",
                    type: "String(250)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('收件人详细地址')
                  },
                ]
              },
              {
                name: "courierReceipt",
                type: "Object",
                require: "N",
                normal: "",
                describe: that.$lang('回单收件信息对象'),
                children: [
                  {
                    name: "name",
                    type: "String(40)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('回单收件人姓名')
                  },
                  {
                    name: "mobile",
                    type: "String(30)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('回单收件人电话')
                  },
                  {
                    name: "prov",
                    type: "String(40)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('回单收件人省')
                  },
                  {
                    name: "city",
                    type: "String(40)",
                    require: "N",
                    normal: "",
                    describe: that.$lang('回单收件人市') + '<br/>' + that.$lang('新地址无需填该字段'),
                    isHtml: true
                  },
                  {
                    name: "area",
                    type: "String(40)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('回单收件人区')
                  },
                  {
                    name: "address",
                    type: "String(250)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('回单收件人详细地址')
                  }
                ]
              },
              {
                name: "items", type: "Array", require: "N", normal: "", describe: that.$lang('物品信息'), children: [
                  {name: "itemName", type: "String(80)", require: "Y", normal: "", describe: that.$lang('物品名称')},
                  {
                    name: "englishName",
                    type: "String(80)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('物品名称英文')
                  },
                  {name: "number", type: "String(20)", require: "Y", normal: "", describe: that.$lang('物品数量')},
                  {
                    name: "itemValue",
                    type: "String(10)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('商品单价，默认币种VND')
                  },
                  {
                    name: "weight",
                    type: "String(80)",
                    require: "N",
                    normal: "",
                    describe: that.$lang('包裹总重量') + '<br/>' + that.$lang('默认 KG，支持 KG、G') + '<br/>' + '0.01kg ≤ weight≤ 999.00kg',
                    isHtml: true
                  },
                ]
              },
              {
                name: "packageInfo",
                type: "Object",
                require: "Y",
                normal: "",
                describe: that.$lang('包裹信息'),
                children: [
                  {
                    name: "weight",
                    type: "String(80)",
                    require: "Y",
                    normal: "0.01kg",
                    describe: that.$lang('包裹总重量') + '<br/>' + that.$lang('默认 KG，支持 KG、G') + '<br/>' + '0.01kg ≤ weight≤ 999.00kg',
                    isHtml: true
                  },
                  {
                    name: "height",
                    type: "String(20)",
                    require: "N",
                    normal: "50cm",
                    describe: that.$lang('单位：cm') + '<br/>' + that.$lang('1.00cm≤height≤180.00cm'),
                    isHtml: true
                  },
                  {
                    name: "length",
                    type: "String(20)",
                    require: "N",
                    normal: "50cm",
                    describe: that.$lang('单位：cm') + '<br/>' + that.$lang('1.00cm≤length≤320.00cm'),
                    isHtml: true
                  },
                  {
                    name: "width",
                    type: "String(20)",
                    require: "N",
                    normal: "50cm",
                    describe: that.$lang('单位：cm') + '<br/>' + that.$lang('1.00cm≤width≤100.00cm'),
                    isHtml: true
                  },
                  {
                    name: "volume",
                    type: "String(20)",
                    require: "N",
                    normal: "0.01kg",
                    describe: that.$lang('体积重=长*高*宽 / 6000') + '<br/>' + that.$lang('小数点后保留两位，四舍五入'),
                    isHtml: true
                  },
                ]
              },
              {
                name: "sendStartTime",
                type: "String",
                require: "N",
                normal: "",
                describe: 'Suggest Pick Up start time' + '<br/>' + '24 Hour :yyyy-MM-dd HH:mm:ss' + '<br/>' + that.$lang('物流公司最早上门取货时间'),
                isHtml: true
              },
              {
                name: "sendEndTime",
                type: "String",
                require: "N",
                normal: "",
                describe: 'Suggest Pick Up end time' + '<br/>' + '24 Hour :yyyy-MM-dd HH:mm:ss' + '<br/>' + that.$lang('物流公司最晚上门取货时间'),
                isHtml: true
              },
              {
                name: "isInsured",
                type: "int",
                require: "Y",
                normal: "0" + "<br/>" + "1",
                describe: that.$lang('是否需要保价'),
                isHtml: true
              },
              {
                name: "goodsValue",
                type: "double",
                require: "Y",
                normal: "",
                describe: that.$lang('物品价值，0VND <= goodsValue <= 30,000,000VND') + '<br/>' + that.$lang('默认币种：VND') + '<br/>' + that.$lang('当isInsured == 1时，用来计算保险费，确认赔偿金额'),
                isHtml: true
              },
              {
                name: "codMoney",
                type: "String(20)",
                require: "N",
                normal: "",
                describe: that.$lang('代收货款，默认币种：VND')
              },
              {
                name: "transportType",
                type: "String(20)",
                require: "N",
                normal: "",
                describe: that.$lang('运输方式，默认：EXPRESS')
              },
              {
                name: "remark",
                type: "String(200)",
                require: "N",
                normal: "",
                describe: that.$lang('备注') + '<br/>' + that.$lang('是否可开箱检查'),
                isHtml: true
              },
            ]
          },
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: "code",
                type: "String(10)",
                require: "Y",
                normal: "1",
                describe: that.$lang('1为成功，其他为失败，此时关注msg中返回的失败原因')
              },
              {name: "msg", type: "String(100)", require: "Y", normal: "success", describe: that.$lang('返回信息')},
              {
                name: "data", type: "Object", require: "Y", normal: "", describe: that.$lang('业务数据'), children: [
                  {name: "billCode", type: "String(20)", require: "N", normal: "", describe: that.$lang('运单号')},
                  {
                    name: "txlogisticId",
                    type: "String(20)",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('客户订单号')
                  },
                  {name: "sortLine", type: "String(20)", require: "Y", normal: "", describe: that.$lang('三段码')},
                  {
                    name: "codFee",
                    type: "BigDecimal",
                    require: "N",
                    normal: "",
                    describe: that.$lang('COD手续费') + '<br/>' + that.$lang('币种：VND') + '<br/>' + '0 <= COD <= 30.000.000',
                    isHtml: true
                  },
                  {
                    name: "insuranceFee",
                    type: "BigDecimal",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('保价费') + '<br/>' + that.$lang('币种：VND'),
                    isHtml: true
                  },
                  {
                    name: "inquiryFee",
                    type: "BigDecimal",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('总运费（如有保险费，则已包含）') + '<br/>' + that.$lang('币种：VND'),
                    isHtml: true
                  }
                ]
              },
            ]
          },
        ],
        // curl示例,\因为要``处理了一个，所以要再加一个\
        curlExample: `curl --location --request POST 'https://demoopenapi.jtexpress.vn/webopenplatformapi/api/order/addOrder' \\
--header 'digest: L6TreZwJOgVGK/5Tfy1RJQ==' \\
--header 'timestamp: 1111111' \\
--header 'apiAccount: 178337126125932605' \\
--header 'User-Agent: Apifox/1.0.0 (https://apifox.com)' \\
--data-urlencode 'bizContent={"customerCode":"LC00001114","txlogisticId":"S0333692","password":"53CD31A6E3AF8A973FDB2369BDADC9FE","orderType":1,"serviceType":1,"sender":{"name":"KHO BYE BÉO BMT - JT","phone":"0905054057","mobile":"0905054057","prov":"Đắk Lắk","city":"Thành phố Buôn Ma Thuột","area":"Phường Tân Hoà-262TPB04","address":"267/22 MAI HẮC ĐẾ"},"receiver":{"name":"0348103599","phone":"0348103599","mobile":"0348103599","prov":"Đồng Nai","city":"Huyện Vĩnh Cửu","area":"Xã Thiện Tân-251HVC10","address":"Địa chỉ: ql56, thôn Quảng Thàn"},"createOrderTime":"2025-06-25 02:56:33","sendStartTime":"2025-06-25 09:56:33","sendEndTime":"2025-06-26 09:56:33","payType":"CC_CASH","itemsValue":1400000,"goodsValue":1400000,"goodsType":"bm000010","deliveryType":1,"items":[{"itemName":"[45] MUTAN BCAA 90SER - Blue Raspbery (hũ)","englishName":"[45] MUTAN BCAA 90SER - Blue Raspbery (hũ)","number":1,"itemValue":1400000}],"totalQuantity":1,"remark":"Hàng dễ vỡ, xin nhẹ tay","productType":"EXPRESS","isInsured":0,"packageInfo":{"weight":"1"},"codMoney":1400000}'`,
        //请求示例
        requestCode: JSON.parse(`{"customerCode":"024E000014","txlogisticId":"12345644555553389101","productType":"EXPRESS","orderType":"1","serviceType":"1","deliveryType":"1","selfAddress":0,"sender":{"name":"zhan","mobile":"02323232323","prov":"Hồ Chí Minh","city":"Quận 1","area":"Phường Nguyễn Thái Bình-028QQ107","address":"test"},"receiver":{"name":"ffff","mobile":"0378456963","prov":"Hồ Chí Minh","city":"Quận 1","area":"Phường Nguyễn Thái Bình-028QQ107","address":"test"},"payType":"PP_CASH","goodsType":"bm000010","goodsValue":"20000","codMoney":"20000","remark":"123","password":"AF798EA591C460FC633D4567EC88E3FB","packageInfo":{"weight":"3","length":10,"width":10,"height":10,"volume":"10"},"itemsValue":"1000","totalQuantity":1,"items":[{"itemName":"goodsName-test","englishName":"Test","number":"1","itemValue":20}]}`),
        //返回示例
        responseCode: JSON.parse(
          `{
  "code": "1",
  "msg": "success",
  "data": {
    "txlogisticId": "123456789101",
    "billCode": "802400616352",
    "sortLine": "800-028A04-",
    "inquiryFee": 15.00,
    "codFee": 0,
    "insuranceFee": 0
  }
}`
        ),


        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
        _headerData: {
          apiAccount: "1001",
          digest: "U40e5sumorgd3YgZzU61Mw==",
          timestamp: "1565238848921",
        },
        data: {
          bizContent: `{"customerCode":"J0086000020","digest":"/bGMxZbpzAtLrplAvEYvqw==","serviceType":"02","countryCode":"CHN","orderType":"2","receiver":{"area":"鼓楼区","address":"南京大学","town":"鼓楼镇","city":"南京市","mobile":"12345678909","mailBox":"ant_li123@qq.com","phone":"075587654321","countryCode":"CHN","street":"大学路","name":"中露姐1","company":"上海天美工作室","postCode":"518000","prov":"江苏省"},"expressType":"EZ","deliveryType":"03","length":30,"sendStartTime":"2020-01-18 15:05:47","weight":20,"remark":"YD9945874130030","txlogisticId":"YL101010101011","goodsType":"bm000001","volume":210,"priceCurrency":"RMB","totalQuantity":6,"sender":{"area":"雨花台区","address":"高新技术产业园","town":"粤海街道","city":"南京市","mobile":"12345678909","mailBox":"ant_li@qq.com","phone":"075512345678","countryCode":"CHN","street":"高新南七道","name":"小露姐1","company":"深圳天丑工作室","postCode":"518000","prov":"江苏省"},"itemsValue":"2000","width":10,"offerFee":1000,"items":[{"englishName":"文件111","number":30,"itemType":"bm000001","itemName":"文件222","priceCurrency":"RMB","itemValue":"2000","chineseName":"文件333","itemUrl":"http://www.baidu.com/#h%?a=10&b=20","desc":"文件"},{"englishName":"文件444","number":50,"itemType":"bm000001","itemName":"文件555","priceCurrency":"RMB","itemValue":"3000","chineseName":"文件666","itemUrl":"http://www.baidu.com/#h%?a=10&b=20","desc":"文件000"}],"sendEndTime":"2020-01-19 15:05:47","height":600}`
        },
        //必须要验证的参数
        requestData: ['apiAccount', 'digest', 'timestamp', 'bizContent'],
        textareaData: {
          bizContent: true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,


      },
    };
  },
  created() {
  },
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
